const renderRecaptcha = () => {
  const container = document.getElementById("recaptcha-container")

  // Check if the container exists on the current page
  if (container) {
    const siteKey = container.firstChild.dataset.sitekey

    // Avoid re-rendering if the widget is already there
    if (!container.querySelector("iframe")) {
      grecaptcha.render(container, {
        sitekey: siteKey,
      })
    }
  }
}

document.addEventListener("turbolinks:load", renderRecaptcha)
